const clearFilterButtonManagementEquip = {
  Typography: 'Limpar'
};

export default clearFilterButtonManagementEquip;
